import React, { useEffect, useState, createElement } from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { LandingPage } from './components/LandingPage';
import { TextLandingPage } from './components/TextLandingPage';
import { TwilioCompliancePage } from './components/TwilioCompliancePage';
import { MainLayout } from './components/layout/MainLayout';
import { Dashboard } from './pages/Dashboard';
import { Transcriptions } from './pages/Transcriptions';
import { TranscriptionDetail } from './pages/TranscriptionDetail';
import { BatchProcessing } from './pages/BatchProcessing';
import { History } from './pages/History';
import { Settings } from './pages/Settings';
import { UserProvider, useUser } from './contexts/UserContext';
import { FeaturesPage } from './components/FeaturesPage';
import { RelationshipLandingPage } from './components/RelationshipLandingPage';
import { Search } from './pages/Search';
const AuthGuard = ({
  children
}: {
  children: React.ReactNode;
}) => {
  const {
    session,
    supabaseUser
  } = useUser();
  const [isGuestMode, setIsGuestMode] = useState(() => {
    return localStorage.getItem('guestMode') === 'true';
  });
  if (session || isGuestMode) {
    return <>{children}</>;
  }
  return <Navigate to="/" data-id="element-0" />;
};
export function App() {
  const [isGuestMode, setIsGuestMode] = useState(() => {
    return localStorage.getItem('guestMode') === 'true';
  });
  useEffect(() => {
    // Check if viewport meta tag exists
    let viewportMeta = document.querySelector('meta[name="viewport"]');
    if (!viewportMeta) {
      // Create and append viewport meta tag if it doesn't exist
      viewportMeta = document.createElement('meta');
      viewportMeta.name = 'viewport';
      viewportMeta.content = 'width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=no';
      document.head.appendChild(viewportMeta);
    } else {
      // Update existing viewport meta tag
      viewportMeta.content = 'width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=no';
    }
  }, []);
  const enableGuestMode = () => {
    localStorage.setItem('guestMode', 'true');
    setIsGuestMode(true);
  };
  const disableGuestMode = () => {
    localStorage.removeItem('guestMode');
    setIsGuestMode(false);
  };
  return <BrowserRouter data-id="element-1">
      <UserProvider data-id="element-2">
        <AppRoutes isGuestMode={isGuestMode} enableGuestMode={enableGuestMode} disableGuestMode={disableGuestMode} data-id="element-3" />
      </UserProvider>
    </BrowserRouter>;
}
function AppRoutes({
  isGuestMode,
  enableGuestMode,
  disableGuestMode
}: {
  isGuestMode: boolean;
  enableGuestMode: () => void;
  disableGuestMode: () => void;
}) {
  const {
    session,
    signOut
  } = useUser();
  const handleLogout = async () => {
    await signOut();
    disableGuestMode();
  };
  return <Routes data-id="element-4">
      <Route path="/" element={session || isGuestMode ? <Navigate to="/app" data-id="element-6" /> : <LandingPage onLogin={enableGuestMode} data-id="element-7" />} data-id="element-5" />
      <Route path="/text" element={<TextLandingPage data-id="element-9" />} data-id="element-8" />
      <Route path="/features" element={<FeaturesPage data-id="element-11" />} data-id="element-10" />
      <Route path="/text/compliance" element={<TwilioCompliancePage data-id="element-13" />} data-id="element-12" />
      <Route path="/relationships" element={<RelationshipLandingPage data-id="element-15" />} data-id="element-14" />
      {/* Public transcript view route */}
      <Route path="/v/:id" element={<TranscriptionDetail data-id="element-17" />} data-id="element-16" />
      <Route path="/app" element={<AuthGuard data-id="element-19">
            <MainLayout onLogout={handleLogout} data-id="element-20" />
          </AuthGuard>} data-id="element-18">
        <Route index element={<Dashboard data-id="element-22" />} data-id="element-21" />
        <Route path="transcriptions" data-id="element-23">
          <Route index element={<Transcriptions data-id="element-25" />} data-id="element-24" />
          <Route path=":id" element={<TranscriptionDetail data-id="element-27" />} data-id="element-26" />
        </Route>
        <Route path="batch" element={<BatchProcessing data-id="element-29" />} data-id="element-28" />
        <Route path="history" element={<History data-id="element-31" />} data-id="element-30" />
        <Route path="search" element={<Search data-id="element-33" />} data-id="element-32" />
        <Route path="settings" element={<Settings data-id="element-35" />} data-id="element-34" />
      </Route>
      <Route path="*" element={<Navigate to="/app" data-id="element-37" />} data-id="element-36" />
    </Routes>;
}